import { useEffect, useState } from 'react';
import { ServiceArea } from '@bringg/types';
import { showAreas } from '../../components/mapbox/mapbox-with-service-areas/utils/service-areas-supervisor';
import { Map as MapboxMap } from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';

const useServiceAreas = (
	map: MapboxMap,
	draw: MapboxDraw,
	getAllServiceAreas: () => Promise<ServiceArea[]>,
	editable: boolean,
	shouldFitBounds: boolean,
	teamId: number
) => {
	const [serviceAreas, setServiceAreas] = useState<ServiceArea[]>([]);

	async function fetchServiceAreas() {
		const response = await getAllServiceAreas();
		setServiceAreas(response);
	}

	useEffect(() => {
		fetchServiceAreas();
	}, []);

	useEffect(() => {
		showAreas(map, draw, serviceAreas, editable, shouldFitBounds, teamId);
	}, [map, draw, serviceAreas]);

	return serviceAreas;
};

export default useServiceAreas;
